export const IMAGES = {
    heroForge:
        "https://images.pexels.com/photos/38846050/pexels-photo-38846050.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    moltenPour:
        "https://images.unsplash.com/photo-1613970351372-9804e380bd09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxtb2x0ZW4lMjBzdGVlbCUyMGZvcmdpbmd8ZW58MHx8fHwxNzg5ODMwNTE1fDA&ixlib=rb-4.1.0&q=85",
    gearsCollection:
        "https://images.unsplash.com/photo-1606337321936-02d1b1a4d5ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxtZXRhbCUyMGF1dG9tb3RpdmUlMjBnZWFycyUyMG1hY2hpbmVyeXxlbnwwfHx8fDE3ODk4MzA1MTV8MA&ixlib=rb-4.1.0&q=85",
    gearsDetail:
        "https://images.pexels.com/photos/7568428/pexels-photo-7568428.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    factory:
        "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxoZWF2eSUyMGluZHVzdHJpYWwlMjBmYWN0b3J5JTIwbWFudWZhY3R1cmluZ3xlbnwwfHx8fDE3ODk4MzA1MTV8MA&ixlib=rb-4.1.0&q=85",
    pipes:
        "https://images.pexels.com/photos/208661/pexels-photo-208661.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const NAV_LINKS = [
    { label: "About", href: "#about" },
    { label: "Capabilities", href: "#capabilities" },
    { label: "Products", href: "#products" },
    { label: "Infrastructure", href: "#infrastructure" },
    { label: "Clients", href: "#clients" },
    { label: "Contact", href: "#contact" },
];

export const MARQUEE_ITEMS = [
    "Closed-Die Forgings",
    "Gravity Die Castings",
    "CNC Precision Machining",
    "Heat Treatment",
    "ISO 9001:2015",
    "IATF 16949:2016",
    "Export Grade Quality",
];

export const CAPABILITIES = [
    {
        id: "casting",
        title: "Casting",
        desc: "Gravity die and sand castings in ferrous and non-ferrous alloys — poured, fettled and finished in-house for consistent metallurgy.",
        stats: ["0.5 – 500 KG PARTS", "FERROUS & AL ALLOYS", "IN-HOUSE FETTLING"],
        image: "moltenPour",
        span: "lg:col-span-7",
    },
    {
        id: "forging",
        title: "Closed-Die Forging",
        desc: "Drop hammers and screw presses shaping near-net forgings with superior grain flow and fatigue strength.",
        stats: ["5T DROP HAMMERS", "1600T SCREW PRESSES", "250K PARTS / MONTH"],
        image: null,
        span: "lg:col-span-5",
    },
    {
        id: "machining",
        title: "Precision Machining",
        desc: "CNC turning and VMC lines with in-house tooling, gauges and CMM inspection — ready-to-assemble components.",
        stats: ["CNC TURNING & VMC", "±0.02 MM TOLERANCE", "CMM INSPECTED"],
        image: "gearsDetail",
        span: "lg:col-span-5",
    },
    {
        id: "process",
        title: "One Roof. Zero Handoffs.",
        desc: "Billet to boxed component — every stage under our roof, every batch traceable.",
        stats: ["BILLET", "FORGE", "HEAT TREAT", "MACHINE", "INSPECT", "DISPATCH"],
        image: null,
        span: "lg:col-span-7",
        chain: true,
    },
];

export const PRODUCTS = [
    {
        name: "Crankshafts",
        spec: "Forged steel · balanced & machined",
        image: "gearsDetail",
        pos: "object-center",
    },
    {
        name: "Connecting Rods",
        spec: "Closed-die forged · shot peened",
        image: "gearsCollection",
        pos: "object-center",
    },
    {
        name: "Gears & Pinions",
        spec: "Transmission & differential",
        image: "gearsCollection",
        pos: "object-bottom",
    },
    {
        name: "Axle Shafts",
        spec: "Induction hardened · spline rolled",
        image: "gearsDetail",
        pos: "object-top",
    },
    {
        name: "Steering Knuckles",
        spec: "Forged & fully machined",
        image: "heroForge",
        pos: "object-center",
    },
    {
        name: "Flanges & Yokes",
        spec: "Driveline & coupling components",
        image: "moltenPour",
        pos: "object-center",
    },
];

export const STATS = [
    { value: "50,000", unit: "SQ FT", label: "Manufacturing facility" },
    { value: "1,200", unit: "MT / MO", label: "Forging capacity" },
    { value: "120+", unit: "", label: "Machines & presses" },
    { value: "12+", unit: "YRS", label: "Of forging heritage" },
];

export const SECTORS = [
    { name: "Commercial Vehicles", icon: "Truck" },
    { name: "Tractors & Agri", icon: "Tractor" },
    { name: "Passenger Vehicles", icon: "Car" },
    { name: "Earthmoving", icon: "Mountain" },
    { name: "Industrial Machinery", icon: "Factory" },
    { name: "Export OEMs", icon: "Globe" },
];

export const CERTS = [
    { code: "ISO 9001:2015", label: "Quality Management System" },
    { code: "IATF 16949:2016", label: "Automotive QMS" },
];

export const CONTACT = {
    address: "No. 519/2, Srinivasa Pillai Nagar, Ayanambakkam, Chennai – 600 095, Tamil Nadu, India",
    phone: "+91 99635 22635",
    email: "contact@svsbalajiindustries.com",
    mdEmail: "MD@svsbalajiindustries.com",
    gst: "33BZEPS6629D1ZB",
    whatsapp: "919963522635",
};
